module.exports = __webpack_public_path__ + "img/exiled.aad3d388.png";